import { render, staticRenderFns } from "./oklens-prescription-popver.vue?vue&type=template&id=d0e07370&scoped=true&"
import script from "./oklens-prescription-popver.vue?vue&type=script&lang=js&"
export * from "./oklens-prescription-popver.vue?vue&type=script&lang=js&"
import style0 from "./oklens-prescription-popver.vue?vue&type=style&index=0&id=d0e07370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e07370",
  null
  
)

export default component.exports